<app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
<div class="row m-0 col-md-12 p-0 formborder" style="align-items: flex-end; padding: 0.625rem 0.9375rem !important;">
  <div class="col-md-4 p-1 mt-2 mb-2">
    <form action="" class="search-text">
      <div class="bg-light rounded rounded-pill shadow-sm">
        <div class="input-group">
          <input
            type="text"
            id="FilterInputSearch"
            (keyup)="applyFilter($event.target.value)"
            name="FilterInputSearch"
            placeholder="What're you searching for?"
            class="form-control border-0 bg-light mt-2"
          />
          <div class="input-group-append">
            <button
              id="button-addon1"
              type="submit"
              class="btn btn-link text-primary"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
<div class="table-responsive mt-3" [hidden]="!dataSource">
  <mat-table
    [dataSource]="dataSource"
    matSort
    matTableExporter
    #exporter="matTableExporter"
    [hiddenColumns]="[
      displayedColumns.indexOf('Edit'),
      displayedColumns.indexOf('Delete')
    ]"
  >
    <ng-container matColumnDef="PartnerId">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        #
      </mat-header-cell>
      <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
        {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Partner">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Dealer
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Partner }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="MobileNo">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Mobile No
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.MobileNo }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Manufactures">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Manufactures
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell">
        {{ row.Manufactures }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Address">
      <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
        Address
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row"
        class="grid-cell"
        data-toggle="tooltip"
        data-placement="left"
        title="{{ row.Address }}"
      >
        {{ row.Address.length > 0 ? row.Address.slice(0, 20) : ""
        }}{{ row.Address.length > 20 ? "..." : "" }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Edit">
      <mat-header-cell
        mat-sort-header
        class="grid-header j-c-center"
        *matHeaderCellDef
      >
        View
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
        <i
          class="fas fa-lg fa-edit"
          (click)="OnOpenPartnerModal(row, $event)"
          style="cursor: pointer; color: black; font-size: 1rem"
          aria-label="true"
        ></i>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
  <div class="row m-0 align-items-center">
    <div class="col-md-4">
      <button
        class="mt-3 btn font-size-12 button-btn"
        (click)="exportTable(exporter)"
      >
        <i class="fa fa-file-export mr-1"></i>
        Export
      </button>
    </div>
    <div class="col-md-8">
      <mat-paginator
        #paginatorRef
        [pageSizeOptions]="[20, 50]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>

<div
  class="modal fade in"
  id="AssignVehiclemanufactureModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <form #dbf="ngForm" novalidate>
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Assign Manufacture and Category For {{ DealerName }}
          </h6>
          <button
            type="button"
            (click)="onCloseModal()"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body" style="border: none">
          <table class="responstable formborder mt-1" id="MainTable">
            <tr>
              <th style="width: 25% !important">
                <span class="required-lable"> Manufacture</span>
              </th>
              <th style="width: 70% !important">
                <span class="required-lable">Category</span>
              </th>
              <th style="width: 10% !important"></th>
            </tr>
            <tr
              *ngFor="
                let Policy of vehicleDealerManufactureDetail;
                let i = index
              "
            >
              <td style="padding-right: 0.625rem">
                <select
                  name="Manufacture{{ i }}"
                  id="Manufacture{{ i }}"
                  #refManufacture="ngModel"
                  (change)="LMS_GetVehicleMaster(Policy, i)"
                  [ngClass]="{
                    'is-invalid': dbf.submitted && refManufacture.invalid,
                    'alert-warning':
                      refManufacture.invalid &&
                      (refManufacture.dirty ||
                        refManufacture.touched ||
                        refManufacture.untouched)
                  }"
                  [(ngModel)]="Policy.Manufacture"
                  class="form-control input-text-css"
                  required
                >
                  <option value="">Select Manufacture</option>
                  <option
                    *ngFor="let Manufacture of ManufactureData"
                    [value]="Manufacture.Id"
                  >
                    {{ Manufacture.Manufacture }}
                  </option>
                </select>
              </td>
              <td>
                <mat-select
                  style="
                    border: 1px solid rgb(33, 170, 162);
                    padding: 0.25rem;
                    border-radius: 0.25rem;
                  "
                  [multiple]="true"
                  name="Category{{ i }}"
                  id="Category{{ i }}"
                  required
                  #refCategory="ngModel"
                  [ngClass]="{
                    'is-invalid': dbf.submitted && refCategory.invalid,
                    'alert-warning':
                      refCategory.invalid &&
                      (refCategory.dirty || refCategory.touched)
                  }"
                  [(ngModel)]="Policy.Category"
                  [placeholder]="
                    Policy.Category?.length ? '' : 'Select Category'
                  "
                >
                  
                  <mat-option
                    *ngFor="let Category of vehicleCategory[i]"
                    [value]="Category.Id"
                  >
                    {{ Category.Vehicle_Category }}
                  </mat-option>
                </mat-select>
              </td>
              <td class="add-remove">
                <button
                  type="button"
                  class="remove"
                  (click)="removeData(i)"
                  [ngClass]="{ 'no-head': i != 0 }"
                  *ngIf="vehicleDealerManufactureDetail.length > 1"
                >
                  -
                </button>
                <button
                  type="button"
                  class="addmore"
                  (click)="addMoreData(i)"
                  [disabled]="!dbf.form.valid"
                  [ngClass]="{
                    both: vehicleDealerManufactureDetail.length > 1,
                    'no-head': i != 0
                  }"
                  *ngIf="i == vehicleDealerManufactureDetail.length - 1"
                >
                  +
                </button>
              </td>
            </tr>
          </table>

          <div class="col-md-1">
            <button
              type="button"
              (click)="onSavevehicleDealerManufactureDetail()"
              class="mt-3 btn font-size-12 button-btn"
              [disabled]="!dbf.form.valid"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
